<!-- 首页 -->
<template>
<div class="container">
    <div class="advert">
        <el-carousel :height="`${windowHeight}px`">
            <el-carousel-item v-for="item in advertList" :key="item.id">
                <img :src="item.imageUrl" alt="" class="advert-img">
            </el-carousel-item>
        </el-carousel>
    </div>
    <div class="">
        <!-- <el-row>
            <el-col :span="12" class="news">
                <div class="flex-row-center">
                    <div class="news-title">新闻栏</div>    
                    <div class="mg-r-15" v-if="roles">                    
                        <el-button type="primary" @click="handleNews">发布新闻</el-button>
                    </div>
                </div>
                <ul class="news-ul">
                    <li v-for="(item,index) in newsList" :key="index" @click="toNews(item.id)">                        
                        <span class="news-title-row">{{ item.title }}</span>
                        <span class="news-date">{{ item.date }}</span>
                    </li>
                </ul>
                <pagination
                    style="position:absolute;bottom:0;right:0"
                    v-show="newsTotal > 10"
                    :total="newsTotal"
                    :page.sync="queryParams2.page"
                    :limit.sync="queryParams2.pagesize"
                    @pagination="initData"
                />
            </el-col>
            <el-col :span="11" class="competition">
                <div class="flex-row-center">
                    <div class="news-title">
                        赛事栏                    
                    </div>
                    <div class="mg-r-15" v-if="roles">                    
                        <el-button type="primary" @click="handlePublish">发布赛事</el-button>
                        <el-button type="success" @click="handleQuery">查看赛事</el-button>
                    </div>
                </div>                
                <div>
                    <ul class="news-ul">
                        <li v-for="(item,index) in competitionList" :key="index" @click="toDetail(item.id)">
                            <span class="news-sai-row">{{ item.title }}</span>
                            <span class="news-status" :class="item.status==='报名中'?'red':''">{{ item.status }}</span>
                            <span class="news-date">{{ item.createDate }}</span>
                        </li>
                    </ul>
                    <el-pagination
                        style="position:absolute;bottom:0;right:0"
                        background
                        @size-change="handleSizeChange"
                        @current-change="getPublishQuery"
                        :current-page.sync="queryParams.page"
                        :page-size="queryParams.pagesize"
                        layout="prev, pager, next"
                        :total="compeTotal">
                        </el-pagination>
                </div>
            </el-col>
        </el-row> -->
        <!-- 新闻与赛事 -->
        <div class="main-content">
            <!-- 左栏：新闻栏 -->
            <div class="left-column">
                <div class="section-card">
                    <div class="card-header">
                        <div class="card-header-content">
                            <i class="fas fa-trophy"></i>
                            <h2>赛事新闻</h2>
                        </div>
                        <div class="card-action" v-if="roles">
                            <button class="action-btn publish-news-btn" @click="handleNews">
                                <i class="fas fa-plus-circle"></i> 新闻发布
                            </button>
                        </div>
                    </div>
                    <div class="news-list">
                        <!-- 新闻项 -->
                        <div class="news-item featured-news" v-for="(item,index) in newsList" :key="index" @click="toNews(item.id)">
                            <div class="news-title">
                                <span>{{ item.title }}</span>
                            </div>
                            <div class="news-meta">
                                <div class="news-date">
                                    <i class="far fa-calendar"></i>{{ item.date }}
                                </div>
                                <span style="font-size: 0.85rem; color: #e74c3c; font-weight: 600;">
                                    <i class="fas fa-eye"></i> 阅读量:{{ item.readCount }}
                                </span>
                            </div>
                            <div class="news-excerpt">
                                {{ item.pureText }}
                            </div>
                        </div>                        
                    </div>                    
                </div>
                <!-- <pagination
                    style="position:absolute;bottom:0;right:0"
                    v-if="newsTotal > 10"
                    :total="newsTotal"
                    :page.sync="queryParams2.page"
                    :limit.sync="queryParams2.pagesize"
                    @pagination="initData"
                /> -->
            </div>
            <!-- 右栏：发布赛事 -->
            <div class="right-column">
                <div class="section-card">
                    <div class="card-header">
                        <div class="card-header-content">
                            <i class="fas fa-bullhorn"></i>
                            <h2>赛事发布</h2>
                        </div>
                        <div class="action-buttons" v-if="roles">
                            <button class="action-btn publish-event-btn" @click="handlePublish">
                                <i class="fas fa-calendar-plus"></i> 发布赛事
                            </button>
                            <button class="action-btn view-all-events-btn" @click="handleQuery">
                                <i class="fas fa-external-link-alt"></i> 查看赛事
                            </button>
                        </div>
                    </div>
                    <div class="event-list">
                        <!-- 赛事项1 -->
                        <div class="event-item" v-for="(item,index) in competitionList" :key="index" @click="toDetail(item.id)">
                            <div class="news-title">
                                {{ item.title }}
                                <span class="event-status" 
                                    :class="getEventStatus(item.status)">{{ item.status }}</span>
                            </div>
                            <div class="news-meta">
                                <div class="news-date">
                                    <i class="far fa-calendar"></i>{{ item.createDate }}
                                </div>
                                <span style="font-size: 0.85rem; color: #e74c3c; font-weight: 600;">
                                    <i class="fas fa-users"></i> 已报名: {{item.amount}}人
                                </span>
                            </div>
                            <p style="color: #666; font-size: 0.95rem; margin-top: 8px;">
                                地点: {{ item.address }}
                            </p>                           
                        </div>                    
                    </div>
                    <!-- <pagination
                        style="position:absolute;bottom:0;right:0"
                        v-if="compeTotal > 10"
                        :total="compeTotal"
                        :page.sync="queryParams.page"
                        :limit.sync="queryParams.pagesize"
                        @pagination="getPublishQuery"
                    /> -->
                </div>
            </div>
        </div>        
        <div class="rank-container mg-t-10">
            <div class="header">
                <h1><i class="fas fa-trophy"></i>排行榜</h1>
                <p>展示选手、裁判及协会俱乐部的实时积分排名，数据定期更新，排名基于综合积分计算。</p>
            </div>        
        <div class="rankings-container">
            <!-- 选手排行榜 -->
            <div class="ranking-section players-section">
                <div class="section-header">
                    <h2><i class="fas fa-user"></i>选手排行榜</h2>
                    <p>顶尖选手积分排名</p>
                </div>
                <div class="ranking-list">
                    <!-- 选手数据通过JavaScript动态生成 -->
                    <div class="rank-item" 
                        :class="[
                            'rank'+'-'+ item.id,{
                            'top-3': item.id <= 3
                        }]"
                       v-for="item in rankPlayerList">
                        <div class="rank-number">{{item.id}}</div>
                        <div class="rank-info">
                            <div class="name">{{item.username}}</div>
                            <div class="details">
                                <span class="level" :class="getLevelClass(item.level)">{{item.level}}</span>
                                <span class="points">{{item.score}}积分</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 裁判排行榜 -->
            <div class="ranking-section judges-section">
                <div class="section-header">
                    <h2><i class="fas fa-gavel"></i>裁判排行榜</h2>
                    <p>专业裁判等级与积分</p>
                </div>
                <div class="ranking-list">
                    <!-- 裁判数据通过JavaScript动态生成 -->
                     <div class="rank-item" 
                        :class="[
                            'rank'+'-'+ item.id,{
                            'top-3': item.id <= 3
                        }]"
                       v-for="item in rankRefereesList">
                        <div class="rank-number">{{item.id}}</div>
                        <div class="rank-info">
                            <div class="name">{{item.username}}</div>
                            <div class="details">
                                <span class="level" :class="getLevelClass(item.level)">{{item.level}}</span>
                                <span class="points">{{item.score}}积分</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 协会/俱乐部排行榜 -->
            <div class="ranking-section clubs-section">
                <div class="section-header">
                    <h2><i class="fas fa-users"></i>协会/俱乐部排行榜</h2>
                    <p>协会与俱乐部积分排名</p>
                </div>
                <div class="ranking-list">
                    <!-- 协会/俱乐部数据通过JavaScript动态生成 -->
                     <div class="rank-item" 
                        :class="[
                            'rank'+'-'+ item.id,{
                            'top-3': item.id <= 3
                        }]"
                        v-for="item in rankClubList">
                        <div class="rank-number">{{item.id}}</div>
                        <div class="rank-info">
                            <div class="name">{{item.username}}</div>
                            <div class="details">
                                <span class="level" :class="getLevelClass(item.level)">{{item.level}}</span>
                                <span class="points">{{item.score}}积分</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="header">
            <p>排行榜仅供参考，最终解释权归主办方所有</p>
        </div>
    </div>
    <section class="partners-header">
        <div class="partners-container">
            <div class="header-content">
                <h1>合作单位</h1>
                <p class="header-subtitle">我们与全国各地的优秀组织建立战略合作伙伴关系，共同推动行业发展和创新</p>
                
                <div class="stats-container">
                    <div class="stat-item">
                        <div class="stat-number">1000+</div>
                        <div class="stat-label">合作俱乐部与协会</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-number">50+</div>
                        <div class="stat-label">顶尖高校与科研机构</div>
                    </div>
                    <div class="stat-item">
                        <div class="stat-number">300+</div>
                        <div class="stat-label">行业专家与顾问</div>
                    </div>
                </div>
            </div>
        </div>
    </section>        
    <section class="description-section">
        <div class="container">
            <div class="description-content">
                <h2 class="description-title">共赢合作，共创未来</h2>
                <p class="description-text">
                    公司自<span class="highlight">2023年成立至今</span>，与全国近<span class="highlight">1000多家俱乐部和协会</span>友好合作，与国内外<span class="highlight">顶尖高校院所、科研机构</span>和数百位国内<span class="highlight">行业专家</span>共赢合作。
                </p>
                <p class="description-text">
                    我们致力于构建开放的合作生态，通过资源共享、技术交流与创新协作，与合作伙伴共同成长，为行业发展注入持久动力。
                </p>
            </div>
        </div>
    </section>    
    <!-- 合作单位展示区 -->
    <section class="partners-section">
        <div class="partners-container">
            <h2 class="section-title">核心合作伙伴</h2>            
            <div class="partners-grid">
                <!-- 合作伙伴卡片 -->
                <div class="partner-card" v-for="item in tableData">
                    <div class="partner-logo">
                        <!-- <i class="fas fa-crown"></i> -->
                         <img :src="item.imageUrl" style="width: 100%;" v-if="item.imageUrl"></img>
                        <!-- <el-image :src="item.imageUrl"></el-image> -->
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">{{ item.name }}</h3>
                        <span class="partner-type club-type" v-if="item.type">{{ item.type }}</span>
                        <p class="partner-description">{{ item.des }}</p>
                    </div>
                </div> 
                <!-- <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-crown"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">金姚记</h3>
                        <span class="partner-type club-type">俱乐部</span>
                        <p class="partner-description">知名棋牌俱乐部，专注于高端竞技平台建设，拥有丰富的赛事组织经验。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-heart"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">天天爱蛋蛋</h3>
                        <span class="partner-type club-type">俱乐部</span>
                        <p class="partner-description">以休闲娱乐为主的社交俱乐部，致力于推广健康益智的棋牌活动。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-running"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">鹰潭市蛋蛋运动协会</h3>
                        <span class="partner-type association-type">行业协会</span>
                        <p class="partner-description">地方性专业协会，推动棋牌运动普及和规范化发展，组织多项地方赛事。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-building"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">复兴集团</h3>
                        <span class="partner-type group-type">企业集团</span>
                        <p class="partner-description">多元化企业集团，在文化娱乐产业有广泛布局，提供资源支持与合作。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-chess-board"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">莆田市蛋蛋运动协会</h3>
                        <span class="partner-type association-type">行业协会</span>
                        <p class="partner-description">地方棋牌运动推广组织，致力于培养专业选手和裁判，提升竞技水平。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-umbrella-beach"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">海南省蛋蛋运动协会</h3>
                        <span class="partner-type association-type">行业协会</span>
                        <p class="partner-description">结合海南旅游资源，打造特色棋牌赛事，推动旅游与体育融合发展。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-chess-queen"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">淮安市淮安区携蛋协会</h3>
                        <span class="partner-type association-type">行业协会</span>
                        <p class="partner-description">区域性专业协会，组织各类培训和比赛，提高棋牌运动的社会影响力。</p>
                    </div>
                </div>                
                <div class="partner-card">
                    <div class="partner-logo">
                        <i class="fas fa-chess-knight"></i>
                    </div>
                    <div class="partner-info">
                        <h3 class="partner-name">泰州市姜堰区扑克协会</h3>
                        <span class="partner-type association-type">行业协会</span>
                        <p class="partner-description">专注于扑克牌竞技的专业协会，培养了大批优秀选手和裁判员。</p>
                    </div>
                </div> -->
            </div>
        </div>
    </section>
    </div>
    <div class="footer">
        <div>Copyright &copy; 2024&nbsp;&nbsp;ICP备案号 苏ICP备2024102048号-1 &nbsp;&nbsp;All Rights Revered.</div>
    </div>
</div>
</template>
<script>
import pagination  from '@/components/Pagination'
import Menu from '@/components/Menu'
import areaList from '@/assets/js/city'
import defaultAvatar from '@/assets/images/avatar.png'
export default {
    components:{
        Menu,
        pagination,
    },
    data() {
        return {
            areaList: areaList.provinces,
            cityList: [],
            ruleForm:{
                provice: '',
                city: '',
            },
            dataList: '',
            newsList: [],
            competitionList: [],
            rankPlayerList: [],
            rankRefereesList: [],
            rankClubList: [],
            associcationOption:[],
            advertList: [],
            queryParams2: {
                page: 1,
                pagesize: 10
            },
            queryParams: {
                page: 1,
                pagesize: 10
            },
            newsTotal: 0,
            compeTotal: 0,
            roleId: null,
            windowHeight:window.innerHeight * 0.5,
            tableData: []
        }
    },
    created() {
        
    },
    mounted() {
        this.initData()
        this.getPublishQuery()
        this.getBannerList()
        // this.getUserRole()
        this.getRankPlayer()
        this.getRankReferees()
        this.getRankClub()
        window.addEventListener('resize', this.handleResize)
        this.companyQuery()
    },
    computed:{
        roles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员' || value === '掼蛋协会' || value === '裁判' || value === '掼蛋俱乐部'){
                return true
            }else{
                return false
            }            
        }
    },
    methods: {
        handleResize() {
            this.windowHeight = window.innerHeight * 0.5
        },
        initData(){
            let params = {
                opcode: this.$code.NewsQuery,
                i_serial: 0,
                v_title: '',               
                start_date: 0,
                end_date: 0,
                pagesize: this.queryParams2.pagesize,
                page: this.queryParams2.page,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.newsTotal = res.Data.SumCount
                    this.newsList = result.map((item,index)=>{
                        let startDate = this.$help.formatDate(item['日期'])                       
                        return{
                            id: item['序号'],
                            title: item['标题'],   
                            readCount: item['阅读数量'],   
                            pureText: this.extractPureText(item['详情']),
                            date: startDate 
                        }
                    }) 
                    // console.log('新闻',result)
                }
            })
        },
        getPublishQuery(){
            let params = {
                opcode: this.$code.PublishQueryPublic,
                i_serial_mark: '',
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: this.queryParams.pagesize,
                page: this.queryParams.page,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.compeTotal = res.Data.SumCount
                    if(result.length > 0){
                        this.competitionList = result.map(item=>{
                            let eventDate = item['赛事结束日期'].slice(0,10)                             
                            // let status = item['状态'] === '赛事中'? '赛事中' : (item['状态']).replaceAll('赛事','')                    
                            return{
                                title: item['主题'],
                                id: item['标识'],
                                createDate:eventDate,
                                status: item['状态'],
                                amount: item['报名人数'],
                                address: item['赛事地点省份']+''+item['赛事地点市']+''+item['赛事地点']
                            }
                        })
                        // console.log('赛事',result)
                    }else{
                        this.competitionList = []
                    }
                }
            })
        },
        getBannerList(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 50  
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    
                    if(result.length > 0){
                        let list = result.map(item=>{
                            return{
                                imageUrl: item['中文描述'],
                                id: item['词条索引']
                            }
                        })   
                        // console.log(list)
                        this.advertList = list
                    }     
                }
            })
        },
         // 获取用户角色
         getUserRole(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 10,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let arr = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                    // let roleName = localStorage.getItem('roles')
                    // this.roleId = (arr.filter(i=>i.label === roleName))[0].value
                    // 1选手 2教练 3裁判  4掼蛋协会 5掼蛋俱乐部 6管理员
                    console.log('角色',arr)
                }
            })
        },    
        // 获取协会角色
        getAssocicationRole(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 11,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.associcationOption = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },   
        getRankPlayer(){
            // 1选手 2教练 3裁判  4掼蛋协会 5掼蛋俱乐部 6管理员
            let params = {
                opcode: this.$code.HomePublicRank,
                v_provice: this.ruleForm.provice,
                v_city: this.ruleForm.city,
                c_type: 1,
                pagesize: 20,
                page: 1
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    
                    let newArr =  result.map(item=>{
                        let imageUrl =  item['头像'] ? this.$global.uploadUrl +''+ item['头像'] : defaultAvatar
                        return{
                            username: item['名称'],
                            avatar: imageUrl,
                            id: item['序号'],
                            level: this.levelToText(item['角色'],item['等级']),
                            score: item['积分'],
                            roleName: item['角色'],
                            provice: item['省'],
                            city: item['市'],
                            userId: item['账号'],
                        }
                    })
                    // console.log(newArr)
                    this.rankPlayerList = newArr
                }
            })
        },
        getRankReferees(){
            // 1选手 2教练 3裁判  4掼蛋协会 5掼蛋俱乐部 6管理员
            let params = {
                opcode: this.$code.HomePublicRank,
                v_provice: this.ruleForm.provice,
                v_city: this.ruleForm.city,
                c_type: 3,
                pagesize: 20,
                page: 1
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    
                    let newArr =  result.map(item=>{
                        let imageUrl =  item['头像'] ? this.$global.uploadUrl +''+ item['头像'] : defaultAvatar
                        return{
                            username: item['名称'],
                            avatar: imageUrl,
                            id: item['序号'],
                            level: this.levelToText(item['角色'],item['等级']),
                            score: item['积分'],
                            roleName: item['角色'],
                            provice: item['省'],
                            city: item['市'],
                            userId: item['账号'],
                        }
                    })
                    // console.log(newArr)
                    this.rankRefereesList = newArr
                }
            })
        },
        getRankClub(){
            // 1选手 2教练 3裁判  4掼蛋协会 5掼蛋俱乐部 6管理员
            let params = {
                opcode: this.$code.HomePublicRank,
                v_provice: this.ruleForm.provice,
                v_city: this.ruleForm.city,
                c_type: 4,
                pagesize: 20,
                page: 1
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    
                    let newArr =  result.map(item=>{
                        let imageUrl =  item['头像'] ? this.$global.uploadUrl +''+ item['头像'] : defaultAvatar
                        return{
                            username: item['名称'],
                            avatar: imageUrl,
                            id: item['序号'],
                            level: this.levelToText(item['角色'],item['等级']),
                            score: item['积分'],
                            roleName: item['角色'],
                            provice: item['省'],
                            city: item['市'],
                            userId: item['账号'],
                        }
                    })
                    // console.log(newArr)
                    this.rankClubList = newArr
                }
            })
        },
        toNews(id){
            this.$router.push({
                path:'newsDetail',
                query:{
                    id: id,
                }
            })
        },
        toDetail(id){
            this.$router.push({
                path:'publishQuery',
                query:{
                    id: id,
                }
            })
        },
        handleApply(){
            this.$router.push('/apply')
        },
        handleNews(){
            this.$router.push('/newsPage')
        },
        handlePublish() {
            this.$router.push('/publish')
        },
        handleQuery(){
            this.$router.push('/newPublishQuery')
        },
        handleChangeArea(value){
            this.cityList = []
            this.ruleForm.provice = value
            this.ruleForm.city = ''
            let cityObj = this.areaList.filter(i=> i.label === value)
            this.cityList = cityObj[0].cities
        },
        handleChangecity(value){
            this.ruleForm.city = value
            if(value){
                this.getRankList()
            }
        },
        handlePreview(){
            this.$router.push('/previewQuery')
        },
        handleSizeChange(val){
            // console.log('1',val)
        },
        handleCurrentChange(val){
            // console.log('2',val,this.queryParams.pagesize)

        },   
        levelToText(role, num){
            if(role === '裁判'){
                const starMap = ['初级', '中级', '高级', '王牌', '金牌'];     
                return starMap[num-1]
            }else{
                const starMap = ['一星', '二星', '三星', '四星', '五星'];
                return starMap[num-1]
            }
        },  
        getLevelClass(level) {
            switch(level) {
                case "二星": return "two-star";
                case "王牌": return "ace";
                case "高级": return "senior";
                case "中级": return "intermediate";
                case "五星": return "five-star";
                case "三星": return "three-star";
                case "一星": return "one-star";
                default: return "one-star";
            }
        },
        // 富文本提取文本
        extractPureText(htmlString) {
            const regex = /<[^>]*>/g; // 匹配所有HTML标签
            return htmlString.replace(regex, ''); // 替换为空字符串
        },
        // 赛事状态
        getEventStatus(status){
            if(status === '赛事中'){
                return  'status-ongoing'
            }else if(status === '赛事报名中'){
                return 'status-registering' 
            }else if(status === '赛事完成'){
                return 'status-completed'
            }else if(status === '积分发放'){
                return 'status-points'
            }
        },
        companyQuery(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 33,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    if(arr.length > 0){
                        this.tableData = arr.map(item=>{
                            let imageUrl = item['图片'] ? this.$global.uploadUrl +item['图片']: ''
                            return{
                                index: item['词条索引'],
                                name: item['中文描述'],
                                imageUrl: imageUrl,
                                mainImageUrl: item['图片'],
                                des: item['备注'],
                                srcList: [imageUrl],
                                type: item.v_type,
                            }
                        }) 
                        // console.log(this.tableData)     
                    }else{
                        this.tableData = []
                    }                                 
                }
            })
        }   
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.content >>> .el-tabs__item.is-active{
    color: #B07F4E;
}
.content >>> .el-tabs__active-bar{
    background-color: #B07F4E;
}
.content >>>  .el-tab-pane{
    font-size: 20px;
    color: #000;
    font-weight: bold;
}
.bold{
    font-weight: bold;
}
.news{
    min-height: 520px;
    border: 0.1px solid #e6e6e6;
    position: relative;
}
.competition{
    margin-left: 40px;
    min-height: 520px;
    border: 0.1px solid #e6e6e6;
    position: relative;
}

.month-color{
    color:#47baff;
}
.quarter-color{
    color:#f8504d
}
.year-color{
    color:#8a5eff
}
.mg-lr{
    margin-left: 15px;
    margin-right: 15px;
}

.cooperation{
    min-height: 100px;
    text-align: center;
}
.coo-item{
    width: 150px;
    height: 100px;
    line-height: 100px;
    background-color: #04a7ea;
    margin-right: 20px;
    border: 1px solid #f1f1f1;
    text-align: center;
    color:#fff;
    font-size: 18px;
    border-radius: 20px;

}
.footer{
    width: 100%;
    padding: 20px 0;
    background-color:#1a1a2e;
    text-align: center;
    color:#fff
}
// banner图
.advert-img{
    width: 100%;
    height: auto;
}
.rank-avatar{
    width:50px;
    height:50px;
    border-radius: 50%;
    margin-left: 10px;
}
// 排行榜样式
.rank-container {
    max-width: 1400px;
    margin: 0 auto;
}

.header {
    text-align: center;
    margin: 20px 0;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.header h1 {
    font-size: 2.8rem;
    color: #2c3e50;
    margin-bottom: 10px;
    position: relative;
    display: inline-block;
}

.header h1:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 4px;
    background: linear-gradient(to right, #3498db, #2ecc71);
    border-radius: 2px;
}

.header p {
    color: #7f8c8d;
    font-size: 1.1rem;
    max-width: 800px;
    margin: 20px auto 0;
    line-height: 1.6;
}

.rankings-container {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    justify-content: center;
}

.ranking-section {
    flex: 1;
    min-width: 350px;
    max-width: 450px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ranking-section:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
}

.section-header {
    padding: 22px 25px;
    color: white;
    position: relative;
    overflow: hidden;
}

.section-header:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
    z-index: 1;
}

.section-header h2 {
    font-size: 1.8rem;
    margin-bottom: 5px;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 10px;
}

.section-header h2 i {
    font-size: 1.4rem;
}

.section-header p {
    font-size: 0.95rem;
    opacity: 0.9;
    position: relative;
    z-index: 2;
}

.players-section .section-header {
    background: linear-gradient(to right, #3498db, #2980b9);
}

.judges-section .section-header {
    background: linear-gradient(to right, #e74c3c, #c0392b);
}

.clubs-section .section-header {
    background: linear-gradient(to right, #2ecc71, #27ae60);
}

.ranking-list {
    padding: 0 5px 20px;
}

.rank-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    margin: 10px 12px;
    border-radius: 12px;
    background: #f9f9f9;
    transition: all 0.2s ease;
    position: relative;
    overflow: hidden;            
}

.rank-item:hover {
    background: #f0f7ff;
    transform: scale(1.01);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.rank-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-weight: 700;
    font-size: 1.2rem;
    color: white;
    border-radius: 50%;
    margin-right: 20px;
    flex-shrink: 0;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    background: linear-gradient(135deg, #3498db, #2980b9);
}

.top-3 .rank-number {
    width: 46px;
    height: 46px;
    font-size: 1.4rem;
}

.rank-1 .rank-number {
    background: linear-gradient(135deg, #ffd700, #ff9800);
}

.rank-2 .rank-number {
    background: linear-gradient(135deg, #c0c0c0, #a0a0a0);
}

.rank-3 .rank-number {
    background: linear-gradient(135deg, #cd7f32, #b87333);
}

.rank-4 .rank-number, .rank-5 .rank-number, .rank-6 .rank-number,
.rank-7 .rank-number, .rank-8 .rank-number, .rank-9 .rank-number,
.rank-10 .rank-number, .rank-11 .rank-number, .rank-12 .rank-number {
    background: linear-gradient(135deg, #3498db, #2980b9);
}

.rank-info {
    flex-grow: 1;
}

.name {
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 5px;
}

.details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.level {
    display: inline-block;
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    color: white;
    text-shadow: 0 1px 1px rgba(0,0,0,0.2);
}

.two-star {
    background: linear-gradient(to right, #3498db, #2e86c1);
}

.ace {
    background: linear-gradient(to right, #e74c3c, #c0392b);
}

.senior {
    background: linear-gradient(to right, #9b59b6, #8e44ad);
}

.intermediate {
    background: linear-gradient(to right, #f39c12, #e67e22);
}

.five-star {
    background: linear-gradient(to right, #ff6b6b, #ee5a52);
}

.three-star {
    background: linear-gradient(to right, #2ecc71, #27ae60);
}

.one-star {
    background: linear-gradient(to right, #95a5a6, #7f8c8d);
}

.points {
    font-size: 1.3rem;
    font-weight: 700;
    color: #2c3e50;
    background: rgba(255, 255, 255, 0.9);
    padding: 6px 15px;
    border-radius: 20px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
}

.players-section .points {
    color: #2980b9;
}

.judges-section .points {
    color: #c0392b;
}

.clubs-section .points {
    color: #27ae60;
}

.footer {
    text-align: center;
    margin-top: 50px;
    padding-top: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: #7f8c8d;
    font-size: 0.9rem;
}

.update-time {
    background: white;
    display: inline-block;
    padding: 8px 20px;
    border-radius: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 15px;
}

@media (max-width: 1200px) {
    .rankings-container {
        gap: 20px;
    }
    
    .ranking-section {
        min-width: 320px;
    }
}

@media (max-width: 768px) {
    .header h1 {
        font-size: 2.2rem;
    }
    
    .ranking-section {
        min-width: 100%;
    }
    
    .rankings-container {
        gap: 25px;
    }
    
    .rank-item {
        padding: 15px;
        margin: 8px 10px;
    }
    
    .details {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .points {
        align-self: flex-end;
    }
}

@media (max-width: 480px) {
    .header h1 {
        font-size: 1.8rem;
    }
    
    .section-header {
        padding: 18px 20px;
    }
    
    .section-header h2 {
        font-size: 1.5rem;
    }
    
    .name {
        font-size: 1.1rem;
    }
    
    .points {
        font-size: 1.1rem;
        padding: 5px 12px;
    }
}

.partners-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
}

/* 头部区域 */
.partners-header {
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    color: white;
    padding: 60px 0 40px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.partners-header:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    z-index: 1;
}

.header-content {
    position: relative;
    z-index: 2;
}

.partners-header h1 {
    font-size: 3.2rem;
    font-weight: 700;
    margin-bottom: 15px;
    letter-spacing: 1px;
}

.header-subtitle {
    font-size: 1.2rem;
    opacity: 0.9;
    max-width: 800px;
    margin: 0 auto 30px;
}

.stats-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 40px;
    margin-top: 40px;
}

.stat-item {
    text-align: center;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 25px 30px;
    min-width: 200px;
    transition: transform 0.3s ease;
}

.stat-item:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.15);
}

.stat-number {
    font-size: 2.8rem;
    font-weight: 700;
    margin-bottom: 8px;
    color: #fff;
}

.stat-label {
    font-size: 1rem;
    opacity: 0.9;
}

/* 描述区域 */
.description-section {
    padding: 40px 0 20px;
    background-color: white;
}

.description-content {
    max-width: 900px;
    margin: 0 auto;
    text-align: center;
}

.description-title {
    font-size: 2.2rem;
    color: #1e3c72;
    margin-bottom: 25px;
    position: relative;
    display: inline-block;
}

.description-title:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(to right, #3498db, #2ecc71);
    border-radius: 2px;
}

.description-text {
    font-size: 1.2rem;
    color: #555;
    line-height: 1.8;
    margin-bottom: 40px;
}

.highlight {
    color: #1e3c72;
    font-weight: 600;
    background: linear-gradient(120deg, #a1c4fd 0%, #c2e9fb 100%);
    padding: 3px 8px;
    border-radius: 4px;
}

/* 合作单位展示区 */
.partners-section {
    padding: 20px 0 0px;
}

.section-title {
    text-align: center;
    font-size: 2.2rem;
    color: #1e3c72;
    margin-bottom: 50px;
    position: relative;
}

.section-title:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: linear-gradient(to right, #3498db, #2ecc71);
    border-radius: 2px;
}

.partners-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 30px;
    margin-top: 40px;
}

.partner-card {
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.4s ease;
    position: relative;
}

.partner-card:hover {
    transform: translateY(-12px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.partner-logo {
    // height: 180px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.partner-logo:before {
    // content: '';
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 100%;
    // background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
    // z-index: 1;
}

.partner-logo i {
    font-size: 4rem;
    color: #1e3c72;
    z-index: 2;
}

.partner-info {
    padding: 25px;
    text-align: center;
}

.partner-name {
    font-size: 1.4rem;
    font-weight: 600;
    color: #1e3c72;
    margin-bottom: 10px;
}

.partner-type {
    display: inline-block;
    padding: 5px 15px;
    background: #eef5ff;
    color: #3498db;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 500;
}

.partner-description {
    color: #666;
    font-size: 0.95rem;
    margin-top: 15px;
    line-height: 1.5;
}

/* 合作类型标签 */
.club-type { background: #e8f6f3; color: #16a085; }
.association-type { background: #fef9e7; color: #f39c12; }
.group-type { background: #f4ecf7; color: #8e44ad; }


/* 主要内容区 */
.main-content {
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin: 0 auto;
    padding: 20px 0 0px;
}
.action-buttons {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
}
        
.left-column, .right-column {
    background-color: #fff;
    flex: 1;
    min-width: 350px;
    position: relative;
}
.publish-news-btn {
    background: #fff;
    color: #333;
}

.publish-event-btn {
    background: #fff;
    color: #333;
}
.action-btn{
    padding: 12px 25px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    border: none;
    z-index: 2;
}
        
/* 新闻卡片通用样式 */
.section-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: transform 0.3s ease;
}

.section-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
}

.card-header {
    padding: 20px 25px;
    background: linear-gradient(135deg, #F43809 0%, #F43809 100%);
    color: white;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-header:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #F43809 0%, #F43809 100%);
    z-index: 1;
}

.card-header-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-header h2 {
    font-size: 1.6rem;
    margin: 0;
}

.card-header i {
    font-size: 1.3rem;
}

.card-action {
    position: relative;
    z-index: 2;
}

.card-btn {
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 6px;
}

.card-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
}

/* 新闻列表样式 */
.news-list, .event-list {
    padding: 0;
    min-height: 500px;
}

.news-item, .event-item {
    padding: 20px 25px;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s ease;
}

.news-item:hover, .event-item:hover {
    background-color: #f9f9f9;
}

.news-item:last-child, .event-item:last-child {
    border-bottom: none;
}

.news-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.news-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 10px;
}

.news-date {
    font-size: 0.9rem;
    color: #7f8c8d;
    display: flex;
    align-items: center;
    gap: 6px;
}

.news-date i {
    font-size: 0.8rem;
}

.news-excerpt {
    color: #666;
    font-size: 0.95rem;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* 赛事状态标签 */
.event-status {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    text-transform: uppercase;
}
.status-registering {
    background: linear-gradient(to right, #3498db, #2980b9);
    color: white;
}

.status-ongoing {
    background: linear-gradient(to right, #e74c3c, #c0392b);
    color: white;
}

.status-completed {
    background: linear-gradient(to right, #2ecc71, #27ae60);
    color: white;
}

.status-points {
    background: linear-gradient(to right, #f39c12, #e67e22);
    color: white;
} 


/* 查看赛事按钮 */
.view-event-btn {
    padding: 8px 16px;
    background: #f8f9fa;
    color: #3498db;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 12px;
}

.view-event-btn:hover {
    background: #e3f2fd;
    border-color: #3498db;
    transform: translateY(-2px);
}
/* 响应式设计 */
@media (max-width: 992px) {
    .main-content {
        flex-direction: column;
    }
    
    .left-column, .right-column {
        width: 100%;
    }
    
    .top-actions {
        flex-direction: column;
        align-items: flex-start;
    }
}

@media (max-width: 768px) {
    .header h1 {
        font-size: 2.2rem;
    }
    
    .header-subtitle {
        font-size: 1rem;
    }
    
    .card-header {
        padding: 18px 20px;
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }
    
    .card-header h2 {
        font-size: 1.4rem;
    }
    
    .news-item, .event-item {
        padding: 15px 20px;
    }
    
    .news-title {
        font-size: 1.1rem;
    }
    
    .pagination-info {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .action-buttons {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    
    .action-btn {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 576px) {
    .header {
        padding: 30px 0 25px;
    }
    
    .header h1 {
        font-size: 1.8rem;
    }
    
    .pagination-controls {
        gap: 5px;
    }
    
    .pagination-btn {
        width: 36px;
        height: 36px;
        font-size: 0.9rem;
    }
    
    .go-to-page {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .news-meta {
        flex-direction: column;
        align-items: flex-start;
    }
}     
  
</style>


// WEBPACK FOOTER //
// src/views/home/home.vue